import React, { useContext, createContext } from "react";

export const ResponsiveContext = createContext(null);
export const ResponsiveContextProvider = ResponsiveContext.Provider;

export function useResponsive() {
  const value = useContext(ResponsiveContext);

  if (value === null) {
    throw new Error("Provider is missing. Please wrap your app with <Responsive> provider!");
  }

  return value;
}
